/**
 * Statement Upload Analytics Event Names
 */
const STATEMENT_UPLOAD_ANALYTICS_EVENTS = {
    SUBMIT_STATEMENTS_CLICKED: 'Statement Upload Submit Statements Clicked',
    AUTO_STATEMENTS_MODAL_DISMISSED: 'Auto Statements Eligible Modal Dismissed',
    TASK_CARD_UPLOAD_CLICKED: 'Statement Upload Task Card Upload Clicked',
    DOCUMENT_UPLOADED: 'Statement Upload Document Uploaded',
    DOCUMENT_DELETED: 'Statement Upload Document Deleted',
} as const;

export default STATEMENT_UPLOAD_ANALYTICS_EVENTS;
